import schemaLdJson from 'src/seo/schemaLdJson'

export default class extends schemaLdJson {
  constructor($this) {
    super($this)
    this.$this = $this
  }

  get seoData() {
    const route = this.$this.$route

    if (route.name === 'GamesByGroup') {
      return this.$this.games?.gameGroup.seoData
    } else if (route.name === 'GamesBySubGroup') {
      const subgroupSlug = this.$this.$route.params.subgroup
      const subgroup = this.$this.games?.gameGroup.subgroups.find((i) => i.slug === subgroupSlug)

      return subgroup?.seoData
    }
  }

  get description() {
    return this.$this.subgroup ? this.$this.subgroup?.meta_description : this.$this.group?.meta_description
  }

  get name() {
    return this.parseH1(this.seoData?.seoText)
  }

  get breadcrumbArray() {
    if (this.$this.subgroup) {
      return [
        {
          '@type': 'Thing',
          '@id': `${this.URL}/ru/${this.$this.$route.params.group}`,
          name: this.$this.subgroup?.name,
        },
        {
          '@type': 'WebPage',
          '@id': `${this.URL}${this.$this.$route.fullPath}`,
          name: `👇${this.name}`,
        },
      ]
    } else {
      return [
        {
          '@type': 'WebPage',
          '@id': `${this.URL}${this.$this.$route.fullPath}`,
          name: `👇${this.name}`,
        },
      ]
    }
  }

  generate() {
    const $this = this.$this

    const json = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: `${this.URL}${$this.$route.fullPath}`,
      name: this.name,
      datePublished: this.seoData?.created,
      dateModified: this.seoData?.updated,
      description: this.description,

      isPartOf: this.isPartOf(),

      primaryImageOfPage: this.logo(),

      publisher: this.publisher(),

      mainEntity: {
        '@type': 'Article',
        name: this.name,
        datePublished: this.seoData?.created,
        dateModified: this.seoData?.updated,
        headline: this.parseHeadline(this.seoData?.seoText),
        author: this.authorCasino(),

        publisher: this.publisher(),
      },

      breadcrumb: this.breadcrumb(this.breadcrumbArray),
    }

    return JSON.stringify(json)
  }
}
